import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import MySidebar from "./Components/Sidebar/Sidebar";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import AddSingleProduct from "./Components/AddProduct/AddSingleProduct";
import ViewCategory from "./Components/Category/ViewCategory";
import ViewProduct from "./Components/AddProduct/ViewProduct";
import AdminAuth from "./Components/LoginRegister/AdminAuthentication";
import OrderHistory from "./Components/Order/OrderHistory";
import OrderDetail from "./Components/Order/OrderDetail";
import BannerList from "./Components/HomeManagment/BannerListMaganement";
import HomePageMangement from "./Components/HomeManagment/HomePageMangement";
import CollectionManagement from "./Components/HomeManagment/CollectionProducts/CollectionManagement";
import CollectionProducts from "./Components/HomeManagment/CollectionProducts/CollectionProducts";
import AddToCollection from "./Components/HomeManagment/CollectionProducts/AddToCollection";
import AddToSponsored from "./Components/HomeManagment/SponserdProducts/AddToSponsored";
import Dashboard from "./Components/Dashboard/Dashboard";
import UserTickets from "./Components/UserTicket/UserTicket";
import TopProduct from "./Components/HomeManagment/TopProduct";
import MarketingAnalytics from "./Components/MarketingAnalytics/MarketingAnalytics";
import AdminUser from "./Components/AdminUser/AdminUser";
import Users from "./Components/User/User";
import ProtectedRoute from "./permissions/ProtectedRoute";
import Profile from "./Components/Profile/Profile";
import { useEffect, useState } from "react";
import apiService from "./services/apiService";
import ApiConfig from "./Config";

const FullScreenLoader = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f7f4ef",
      zIndex: 9999,
    }}
  >
    {/* <PropagateLoader color="#977743" size={12} /> */}
  </div>
);
// Initialize guest token before rendering the routes.
const GuestTokenInitializer = ({ children }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const initializeToken = async () => {
      try {
        const sessionToken = sessionStorage.getItem("newToken");
        const localToken = localStorage.getItem("newToken");

        const existingToken = sessionToken || localToken;

        // Preserve any existing token, including older login sessions
        // that might not yet have a tokenType saved.
        if (existingToken) {
          if (!cancelled) {
            setInitialized(true);
          }
          return;
        }

        console.info("Creating guest token...");

        const response = await apiService.post(ApiConfig.guestToken, {});

        // Handles a standard Axios response and common wrapped responses.
        const responseBody = response?.data ?? response;
        const data = responseBody?.data ?? responseBody;
        const guestToken = data?.token;

        if (typeof guestToken !== "string" || !guestToken.trim()) {
          throw new Error("Guest token missing from API response");
        }

        if (cancelled) return;

        // Store the raw JWT exactly as returned by the backend.
        sessionStorage.setItem("newToken", guestToken);
        sessionStorage.setItem("tokenType", "guest");

        console.info("Guest token initialized successfully.");
      } catch (error) {
        console.error(
          "Guest token initialization failed:",
          error.response?.data || error.message,
        );
      } finally {
        if (!cancelled) {
          setInitialized(true);
        }
      }
    };

    initializeToken();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!initialized) {
    return <FullScreenLoader />;
  }

  return children;
};
const AppContent = () => {
  const location = useLocation();
  const hideLayout = location.pathname === "/";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
      }}
    >
      {hideLayout ? (
        <Routes>
          <Route path="/" element={<AdminAuth />} />
        </Routes>
      ) : (
        <MySidebar>
          <Box
            component="main"
            sx={{
              width: "100%",
              minHeight: "100vh",
              overflowY: "auto",
            }}
          >
            <Routes>
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute permission="Dashboard">
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/product"
                element={
                  <ProtectedRoute permission="ViewProduct">
                    <ViewProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/add-single-product"
                element={
                  <ProtectedRoute permission="AddSingleProduct">
                    <AddSingleProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/category"
                element={
                  <ProtectedRoute permission="ViewCategory">
                    <ViewCategory />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/collections"
                element={
                  <ProtectedRoute permission="CollectionManagement">
                    <CollectionManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order-history"
                element={
                  <ProtectedRoute permission="OrderHistory">
                    <OrderHistory />
                  </ProtectedRoute>
                }
              />
              {/* Web and App Home Management   */}

              <Route
                path="/managehome"
                element={
                  <ProtectedRoute permission="HomePageMangement">
                    <HomePageMangement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/managehome/banner"
                element={
                  <ProtectedRoute permission="BannerList">
                    <BannerList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/managehome/top-product"
                element={
                  <ProtectedRoute permission="TopProduct">
                    <TopProduct />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/collection/:id"
                element={
                  <ProtectedRoute permission="CollectionProducts">
                    <CollectionProducts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orderDetails/:id"
                element={
                  <ProtectedRoute permission="OrderDetail">
                    <OrderDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/addToCollection"
                element={
                  <ProtectedRoute permission="AddToCollection">
                    <AddToCollection />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sponsered-products"
                element={
                  <ProtectedRoute permission="AddToSponsored">
                    <AddToSponsored />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/top-products"
                element={
                  <ProtectedRoute permission="TopProduct">
                    <TopProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ticket"
                element={
                  <ProtectedRoute permission="UserTickets">
                    <UserTickets />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/marketing-analytics"
                element={
                  <ProtectedRoute permission="MarketingAnalytics">
                    <MarketingAnalytics />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-management"
                element={
                  <ProtectedRoute permission="AdminUser">
                    <AdminUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-management"
                element={
                  <ProtectedRoute permission="Users">
                    <Users />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profile"
                element={
                  <ProtectedRoute permission="Profile">
                    <Profile />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Box>
        </MySidebar>
      )}
    </Box>
  );
};

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <GuestTokenInitializer>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <AppContent />
          </Router>
        </ThemeProvider>
      </GuestTokenInitializer>
    </ColorModeContext.Provider>
  );
}

export default App;
